

(function () {
    'use strict';
    angular.module('SMART2').directive('smartAccordion', ['$timeout','$parse','$rootScope', function ($timeout,$parse,$rootScope) {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            scope: true,
            link: function (scope, elem, attr) {
                var accordian = {
                    target: elem.find('.accordion-header'),
                    content: elem.find('.accordion-content')
                }, onChange = $parse(attr.onChange);

                accordian.target.data('isOpen', false);
                accordian.content.hide(0).slideUp(0);

                attr.$observe('show', function (a, b) {
                    showHideAccordian.call(accordian.target, a == 'true' ? true : false);
                });

                accordian.target.click(function () {
                    showHideAccordian.call(this, !$(this).data('isOpen'));
                    accEvents();
                    scope.$digest();
                });
                function accEvents() {
                    onChange(scope, {
                        e: {
                            isOpen: accordian.target.data('isOpen')
                        }
                    });
                   
                }
                function showHideAccordian(val) {
                    var _this = $(this),
                        _isOpen = _this.data("isOpen");
                    if (val && !_isOpen) {
                        _this.data("isOpen", true);
                        accordian.content.slideDown();
                    } else if (!val && _isOpen) {
                        _this.data("isOpen", false);
                        accordian.content.slideUp();
                    };
                };
            },
            template: "<div class='smart-accordion-container' ng-transclude></div>"
        }
    }]);
})();